import Cookies from 'js-cookie'
import Errors from '@shared/errors';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const initialState = () => {
    return {
        status: '',
        profile: {},
        team: {},
        userErrors: new Errors()
    }
}

const state = {
   initialState: initialState,
   ...initialState(),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
